import { realBricksApi } from '../../utils/axiosInterceptors';

export const getFavorite = async (data = {}, { rejectWithValue }) => {
  const { onFail = () => {}, ...params } = data;
  const { propertyTypes = [], searchQuery = '', owned, page = 1, perPage = 10 } = params;
  let urlParams = `?page=${page}&perPage=${perPage}`;
  Object.keys(params).forEach((key) => {
    switch (key) {
      case 'propertyTypes':
        propertyTypes.forEach((type) => {
          urlParams += `&propertyType[]=${type}`;
        });
        break;
      case 'owned':
        urlParams += `&ownedProperties=${owned}`;
        break;
      case 'searchQuery':
        urlParams += `&search=${searchQuery}`;
        break;

      default:
        break;
    }
    // if (!urlParams.startsWith('?')) {
    //   urlParams = `?${urlParams}`;
    // }
  });
  try {
    const response = await realBricksApi.get(`/api/v1/properties/favourites${urlParams}`);
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const addOrRemoveToFavourite = async (data = {}, { rejectWithValue }) => {
  const { propertyId, onFail = () => {}, onSuccess = () => {} } = data;
  try {
    await realBricksApi.put(`/api/v1/properties/like`, {
      propertyId: propertyId?.toString(),
    });
    onSuccess();
    return propertyId;
  } catch (err) {
    onFail(propertyId);
    return rejectWithValue(err?.response?.data?.message);
  }
};
